<template>
  <div>
    <div v-if="image" class="preview-image">
      <img :src="image.previewUrl">
      <light-button :title="i18n.t('administrative.delete')" class="btn-sm delete-button" @click="deleteImage">
        <i class="icon-cancel" />
      </light-button>
    </div>

    <light-button :label="addOrEditText" @click="openModal" />

    <select-image-and-crop-modal ref="modal" :allow-cropping="allowCropping" :allow-external-image="allowExternalImage"
                                 :aspect-ratio="aspectRatio"
                                 :image="image" :entity-type="entityType" :field-name="fieldName"
                                 :image-base-url="imageBaseUrl" :preview-style="previewStyle"
                                 :external-image-attribution-utm-params="externalImageAttributionUtmParams"
                                 :external-image-photo-retrieval-url-with-placeholder="externalImagePhotoRetrievalUrlWithPlaceholder"
                                 :external-image-search-url="externalImageSearchUrl"
                                 @image-updated="updateImage" />
  </div>
</template>

<script>
import ajax from '../helpers/ajax'
import LightButton from '../components/buttons/light-button'
import SelectImageAndCropMixin from './select-image-and-crop-mixin'

export default {
  components: { LightButton },

  mixins: [SelectImageAndCropMixin],

  props: {
    allowExternalImage: {
      type: Boolean,
      required: false,
      default: false
    },
    initialImage: {
      type: Object,
      required: false
    },
    entityType: {
      type: String,
      required: true
    },
    externalImageAttributionUtmParams: {
      type: Object,
      required: false
    },
    externalImagePhotoRetrievalUrlWithPlaceholder: {
      type: String,
      required: false
    },
    externalImageSearchUrl: {
      type: String,
      required: false
    }
  },

  computed: {
    addOrEditText() {
      if (this.image) {
        return this.i18n.t('components.image_upload.edit')
      } else {
        return this.i18n.t('components.image_upload.new')
      }
    }
  },

  methods: {
    deleteImage() {
      ajax.delete({
        url: this.imageBaseUrl,
        successHandler: () => {
          this.updateImage(null)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .preview-image {
    position: relative;
    min-height: 50px;

    .delete-button {
      position: absolute;
      top: 10px;
      left: 5px;
      padding: 2px 4px;
    }
  }
</style>
